import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import ConnectionItem from './connection-item';
import { getMenuItemListStyles } from '../styles/menu-item-styles';

class ConnectionItemList extends React.PureComponent {
  render() {
    const {
      classes,
      items,
      onConnectionItemClick,
      isExpanded,
    } = this.props;

    const cnames = classNames([classes.menuList, 'connections-list']);

    return (
      isExpanded &&
      <div className={cnames} style={{ marginTop: '0px' }}>
        {items.map(connection =>
          (
            <ConnectionItem
              key={connection.Id}
              node={connection}
              isExpanded={isExpanded}
              renderText={connection.Account}
              onItemClick={onConnectionItemClick}
            />
        ))}
      </div>
    );
  }
}

ConnectionItemList.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemListStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    Status: PropTypes.string.isRequired,
  })),
  onConnectionItemClick: PropTypes.func.isRequired,
};

ConnectionItemList.defaultProps = {
  items: [],
};

export const StyledConnectionItemList = withDefaultStyles(ConnectionItemList, getMenuItemListStyles);
